import axios from 'axios';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

// ---------------------------------
// Variables
// ---------------------------------

const newsContainer = document.querySelector('#news-container');
let paginationAjax = document.querySelector('#pagination-ajax');

// ---------------------------------
// Functions
// ---------------------------------

const paginateLinks = (el) => {
	let pageLinks = el.querySelectorAll('a');

	Array.from(pageLinks).forEach((link) => {
		link.onclick = (e) => {
			e.preventDefault();
			ajaxLoadMore('load', Number(link.innerText));
		};
	});
};

// ---------------------------------
// AJAX LOAD MORE
// ---------------------------------

const ajaxLoadMore = (requestType, pageNumber) => {
	let current_page = pageNumber;

	let params = new URLSearchParams();

	params.append('action', 'load_more_posts');
	params.append('current_page', current_page);

	axios
		.post('/wp-admin/admin-ajax.php', params)
		.then((res) => {
			let post_grid = document.querySelector('.ajax-wrapper');
			if (res.data) {
				gsap.to(window, { duration: 0.3, scrollTo: newsContainer });

				console.log('res.data', res.data);
				post_grid.innerHTML = res.data.content;
			} else {
				// No more posts to load
				post_grid.innerHTML +=
					'<div class="col-12"><p>No more articles available.</p></div>';
			}
		})
		.then(() => {
			paginationAjax = document.querySelector('#pagination-ajax');
			paginateLinks(paginationAjax);
			// Load in new elements with fade
			let loadedBlogs = document.querySelectorAll('.loaded-ajax');
			Array.from(loadedBlogs).forEach((blog) => {
				setTimeout(() => {
					blog.classList.remove('loaded-ajax');
				}, 50);
			});
		});
};

// ---------------------------------
//  Load More Trigger
// ---------------------------------

document.addEventListener('DOMContentLoaded', () => {
	if (typeof paginationAjax != 'undefined' && paginationAjax != null) {
		paginateLinks(paginationAjax);
	}
});
